(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawly-ball-play"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pw-ball-play'))customElements.define('pw-ball-play',class extends HTMLElement{
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
    this.tabs=[...this.querySelectorAll('[role="tab"]')];this.panels=[...this.querySelectorAll('[role="tabpanel"]')];
    this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index),options);tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.select(next);this.tabs[next].focus();},options);});
    this.select(0);
    this.querySelector('[data-play-shop]')?.addEventListener('click',event=>{const form=document.querySelector('pw-product .pw-main-form');if(!form)return;event.preventDefault();const block=form.closest('.pw-product-block');const target=block?.previousElementSibling||block||form;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});const control=target.querySelector('input:checked,select,button,input:not([type="hidden"])');control?.focus({preventScroll:true});},options);
  }
  select(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});this.panels.forEach((panel,i)=>{panel.hidden=i!==index;if(i!==index)panel.querySelectorAll('video').forEach(video=>video.pause());});}
  disconnectedCallback(){this.abort?.abort();this.querySelectorAll('video').forEach(video=>video.pause());}
});

  } catch(e) { console.error(e); }
})();
})();
